import React, { useEffect } from 'react';
import '../styles/UnifiedStarBackground.css';

interface UnifiedStarBackgroundProps {
  variant?: 'primary' | 'secondary' | 'accent';
}

const UnifiedStarBackground: React.FC<UnifiedStarBackgroundProps> = ({ variant = 'primary' }) => {
  useEffect(() => {
    const createStars = () => {
      const starContainer = document.querySelector('.unified-star-container');
      if (!starContainer) return;

      starContainer.innerHTML = '';

      // Create 150 stars with different sizes and animations
      for (let i = 0; i < 150; i++) {
        const star = document.createElement('div');
        star.className = `unified-star ${variant}`;
        
        star.style.left = `${Math.random() * 100}%`;
        star.style.top = `${Math.random() * 100}%`;
        
        const size = Math.random() * 3;
        star.style.width = `${size}px`;
        star.style.height = `${size}px`;
        
        star.style.animationDelay = `${Math.random() * 3}s`;
        
        starContainer.appendChild(star);
      }

      // Create 15 shooting stars
      for (let i = 0; i < 15; i++) {
        const shootingStar = document.createElement('div');
        shootingStar.className = `unified-shooting-star ${variant}`;
        
        shootingStar.style.left = `${Math.random() * 100}%`;
        shootingStar.style.top = `${Math.random() * 100}%`;
        shootingStar.style.animationDelay = `${Math.random() * 15}s`;
        
        starContainer.appendChild(shootingStar);
      }
    };

    createStars();
    window.addEventListener('resize', createStars);

    return () => {
      window.removeEventListener('resize', createStars);
    };
  }, [variant]);

  return (
    <div className={`unified-star-background ${variant}`}>
      <div className="unified-star-container"></div>
      <div className={`unified-gradient-overlay ${variant}`}></div>
    </div>
  );
};

export default UnifiedStarBackground;